/* eslint-disable prefer-rest-params, prefer-spread, no-unused-expressions */
import { LibCategories } from "src/utils/consent";
import { loadScript } from "src/utils/scriptLoader";

declare const window: Window & {
  axon?: any;
};

export const AXON_EVENT_KEY = "087efaaa-a77a-44b4-8ac9-515c3b1adfc2";

if (!window.axon) {
  // eslint-disable-next-line func-names
  const a: any = function () {
    a.performOperation
      ? a.performOperation.apply(a, arguments)
      : a.operationQueue.push(arguments);
  };
  window.axon = a;

  a.operationQueue = [];
  a.ts = Date.now();
  a.eventKey = AXON_EVENT_KEY;

  // Queue init call immediately - scripts will process it when they load
  a("init");
}

export async function loadApplovin() {
  // Load both Applovin pixel scripts
  // The axon object is already set up and init is queued above
  await Promise.all([
    loadScript("https://s.axon.ai/pixel.js", [LibCategories.targetingCookies], {
      enableCORS: false,
    }),
    loadScript(
      "https://res4.applovin.com/p/l/loader.iife.js",
      [LibCategories.targetingCookies],
      {
        enableCORS: false,
      }
    ),
  ]);
}
